import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=6060004c&scoped=true&"
import script from "./ContentCard.vue?vue&type=script&lang=js&"
export * from "./ContentCard.vue?vue&type=script&lang=js&"
import style0 from "./ContentCard.vue?vue&type=style&index=0&id=6060004c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060004c",
  null
  
)

export default component.exports